var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled_no_stroke",
    d: "M106.5 50.1c-.2-.2-.4-.4-.6-.4H78.5c-.4 0-.7.4-.7.9v7.7c0 .5.3.9.7.9h11.9L64.7 84.9c-.2.2-.3.4-.3.6s.1.5.3.6l5.4 5.4c.3.3 1 .3 1.3 0L97 65.8v25.1c0 .4.4.7.9.7h7.7c.5 0 .9-.3.9-.7V50.2c0-.1 0-.3-.2-.4M71.7 49.8H35.8c-.2 0-.4.1-.6.4-.1.1-.2.3-.2.4v40.7c0 .4.4.7.9.7h7.7c.5 0 .9-.3.9-.7V66.2l15.2 15.2c.3.3.8.2 1.2-.1l5.4-5.4c.4-.4.4-.9.1-1.2L51.1 59.4h20.4c.4 0 .7-.4.7-.9v-7.7c0-.5-.3-.9-.7-.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBox);
export default __webpack_public_path__ + "static/media/dataBox.38c793089c32992c67bfb1338d636ca0.svg";
export { ForwardRef as ReactComponent };